import React from 'react';
import SEOHead from '../components/SEOHead';
import { Store, Mail, Phone, Globe } from 'lucide-react';
import { BUSINESS, HOSTING_PROVIDER, OPERATORS, STORES, storeAddressDisplay } from '../constants/stores';

// Impresszum (Ekertv. 4. §): a két üzletet KÉT KÜLÖN egyéni vállalkozó
// üzemelteti, ezért MINDKETTŐ adatait fel kell tüntetni. A TODO_KITOLTENDO
// értékek a stores.js-ben (OPERATORS / BUSINESS) töltendők ki – itt az oldal
// csak megjeleníti őket, kitalált adat nem kerülhet ki.
const Row = ({ label, value }) => (
  <div className="flex flex-col sm:flex-row sm:gap-2 text-sm py-1.5 border-b border-gray-100 last:border-b-0">
    <span className="text-gray-500 sm:w-56 flex-shrink-0">{label}</span>
    <span className={`font-medium ${String(value).startsWith('TODO_') ? 'text-orange-600' : 'text-ink'}`}>{value}</span>
  </div>
);

const ImpresszumPage = () => (
  <div className="min-h-screen bg-white" data-testid="impresszum-page">
    <SEOHead
      title="Impresszum | NorbiPhone"
      description="A norbiphone.hu üzemeltetőinek adatai: a belvárosi és a Tesco üzletsori üzletet üzemeltető egyéni vállalkozók elérhetőségei."
      url="https://norbiphone.hu/impresszum/"
    />
    <section className="pt-24 pb-16 lg:pt-32">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <h1 className="text-3xl sm:text-4xl font-bold text-ink mb-3">Impresszum</h1>
        <p className="text-gray-600 mb-4">
          A norbiphone.hu weboldalon megjelenő két orosházi üzletet két külön
          egyéni vállalkozó üzemelteti. Az elektronikus kereskedelmi
          szolgáltatásokról szóló 2001. évi CVIII. törvény (Ekertv.) 4. §-a
          alapján az alábbi adatokat tesszük közzé.
        </p>
        <p className="text-gray-600 mb-10">
          A NorbiPhone két üzletét két külön adatkezelő (egyéni vállalkozó)
          üzemelteti. A két adatkezelő nem közös adatkezelő: mindegyik önállóan,
          kizárólag a saját üzletében kezelt személyes adatokért felel.
          Adatkezeléssel kapcsolatos megkeresését kérjük ahhoz az
          üzlethez/adatkezelőhöz intézze, ahol kiszolgáltuk.
        </p>

        {OPERATORS.map((op) => {
          const store = STORES[op.storeKey];
          return (
            <div key={op.storeKey} className="mb-8 rounded-2xl border border-gray-200 p-6" data-testid={`impresszum-operator-${op.storeKey}`}>
              <div className="flex items-center gap-2 mb-4">
                <Store size={20} className="text-brand" />
                <h2 className="text-xl font-bold text-ink">{op.storeLabel}</h2>
              </div>
              <Row label="Szolgáltató (üzemeltető) neve" value={op.name} />
              <Row label="Nyilvántartási szám (e.v.)" value={op.registrationNumber} />
              <Row label="Adószám" value={op.taxId} />
              <Row label="Székhely" value={op.registeredOffice} />
              <Row label="Üzlet címe" value={storeAddressDisplay(store)} />
              <Row label="Telefon" value={op.phoneDisplay || store.phoneDisplay} />
              <Row label="E-mail" value={op.email} />
            </div>
          );
        })}

        <div className="rounded-2xl border border-gray-200 p-6 mb-8">
          <h2 className="text-xl font-bold text-ink mb-4">Közös elérhetőségek</h2>
          <ul className="space-y-2 text-sm text-gray-700">
            <li className="flex items-center gap-2">
              <Globe size={16} className="text-brand" /> {BUSINESS.url.replace('https://', '')}
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-brand" />
              <a href={`mailto:${BUSINESS.email}`} className="text-brand hover:underline">{BUSINESS.email}</a>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={16} className="text-brand" /> {STORES.belvaros.phoneDisplay} (Belváros) · {STORES.tesco.phoneDisplay} (Tesco üzletsor)
            </li>
          </ul>
        </div>

        <div className="rounded-2xl border border-gray-200 p-6 mb-8" data-testid="impresszum-hosting">
          <h2 className="text-xl font-bold text-ink mb-4">Tárhelyszolgáltató</h2>
          <Row label="Név" value={HOSTING_PROVIDER.name} />
          <Row label="E-mail" value={HOSTING_PROVIDER.email} />
          <Row label="Szolgáltatás" value={HOSTING_PROVIDER.service} />
          <Row label="Adatkezelés helye / továbbítás" value={HOSTING_PROVIDER.location} />
          <Row label="Jogalap" value={HOSTING_PROVIDER.legalBasis} />
        </div>

        <p className="text-xs text-gray-500">
          A panaszkezelésről és a fogyasztói jogokról az{' '}
          <a href="/aszf/" className="text-brand hover:underline">ÁSZF</a>-ben,
          az adatkezelésről az{' '}
          <a href="/adatkezeles/" className="text-brand hover:underline">Adatkezelési tájékoztatóban</a>{' '}
          találsz részleteket.
        </p>
      </div>
    </section>
  </div>
);

export default ImpresszumPage;
